import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API } from "@/App";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { FileSignature, Receipt } from "lucide-react";

const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;

export const CustomerContractsCard = ({ leadId }) => {
  const navigate = useNavigate();
  const [contracts, setContracts] = useState([]);
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    if (!leadId) return;
    Promise.all([axios.get(`${API}/contracts`, { params: { lead_id: leadId } }), axios.get(`${API}/invoices`, { params: { lead_id: leadId } })])
      .then(([c, i]) => { setContracts(c.data); setInvoices(i.data); })
      .catch(() => {});
  }, [leadId]);

  if (!contracts.length && !invoices.length) return null;

  return (
    <Card data-testid="customer-contracts-card">
      <CardHeader><CardTitle className="text-base flex items-center gap-2"><FileSignature className="w-4 h-4" /> Contracts &amp; Invoices</CardTitle></CardHeader>
      <CardContent className="space-y-2">
        {contracts.map(c => (
          <div key={c.contract_id} className="flex items-center justify-between p-2 rounded hover:bg-slate-50 cursor-pointer" onClick={() => navigate(`/contracts/${c.contract_id}`)} data-testid={`customer-contract-${c.contract_id}`}>
            <div><p className="text-sm font-medium">{c.contract_number}</p><p className="text-xs text-slate-500">Contract · {money(c.total)}</p></div>
            <Badge variant="outline" className={c.status === "signed" ? "border-green-300 text-green-700" : ""}>{c.status}</Badge>
          </div>
        ))}
        {invoices.map(i => (
          <div key={i.invoice_id} className="flex items-center justify-between p-2 rounded hover:bg-slate-50 cursor-pointer" onClick={() => navigate(`/invoices/${i.invoice_id}`)} data-testid={`customer-invoice-${i.invoice_id}`}>
            <div><p className="text-sm font-medium flex items-center gap-1"><Receipt className="w-3.5 h-3.5 text-emerald-600" /> {i.invoice_number}</p><p className="text-xs text-slate-500">Balance {money(i.balance_due)}</p></div>
            <Badge variant="outline" className={i.status === "paid" ? "border-green-300 text-green-700" : ""}>{i.status.replace("_", " ")}</Badge>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
